
import { NavLink } from 'react-router-dom';

export const AdminImportNavBar = () => {

    const setClassName = ({isActive, isPending}) => {

        const commonClass = "p-2 no-underline border-l border-r"

        if(isActive) {
            return `${commonClass} text-primary`
        } else if(isPending) {
            return `${commonClass} text-secondary`
        } else {
            return `${commonClass} text-gray-400`
        }
    }

    return (
        <div className="flex flex-row border-b border-gray-300 ">
            <NavLink to="/admin/imports/users" className={setClassName}>
                Import d&apos;utilisateurs
            </NavLink>
        </div>
    );
};

